import React from "react";
import cx from "classnames";
import styles from "./FilterList.module.css";
import SearchPageList from "../../Elements/SearchPageList/SearchPageList";
import Pagination from "../../Elements/Pagination/Pagination";
import NewsThumbNailLoadingSkeleton
    from "../../NewsCompo/Loading/NewsThumbNailLoadingSkeleton/NewsThumbNailLoadingSkeleton";
import uuid from "react-uuid";
import {slugGenerator} from "../../../lib/slugGenerator";
import CardList from "../../Elements/CardList/CardList";
import TagList from "../../Elements/TagList/TagList";
import CategoryList from "../../Elements/CategoryList/CategoryList";

const FilterList = ({
                        activeSearch,
                        setActiveSearch,
                        catList,
                        finalCat,
                        setFinalCat,
                        notResultFound,
                        loadingPosts,
                        data,
                        totalPage,
                        activePage,
                        setActivePage,
                        pageNeedsRefresh,
                        setPageNeedsRefresh,
                        finalTag = undefined,
                        setFinalTag = () => {},
                        tagTitle,
                        selectedTagName,
                        catTitle,
                    }) => {
    return (
        <div
            className={cx(
                styles.container,
                "d-flex",
                "align-items-center",
                "justify-content-start",
                "flex-column"
            )}
        >
            {/* ====== list of video and filtering control wrapper */}
            <div
                className={cx(
                    styles.innerContainer,
                    "d-flex",
                    "w-100",
                    "flex-column",
                    "justify-content-start",
                    "align-items-center"
                )}
            >
                {/* ===================   search and tag filter */}
                <div className="w-100 d-flex align-items-center justify-content-center px-1">
                    <div className="d-flex align-items-center justify-content-start w-100 flex-fill">
                        {/* ===== component for controling active serch */}
                        <SearchPageList value={activeSearch} setValue={setActiveSearch}/>
                    </div>

                    {finalTag && (
                        <div className="d-flex align-items-center justify-content-center">
                            <TagList tagTitle={tagTitle} setFinalTag={setFinalTag}
                                     selectedTagName={selectedTagName}/>
                        </div>
                    )}
                </div>

                {/* ===================   category filter */}
                {catList?.length > 0 && (
                    <div className="w-100 d-flex align-items-center justify-content-start px-1">
                        <CategoryList
                            catList={catList}
                            activeCat={finalCat}
                            setActiveCat={setFinalCat}
                            catTitle={catTitle}
                        />
                    </div>
                )}

                {notResultFound ? (
                    <div className="w-100 d-flex align-items-center justify-content-center p-5">
                        <h4 className={cx(styles.notResultStyles)}>{`نتیجه‌ای ${
                            activeSearch ? 'برای " ' + activeSearch + ' "' : ""
                        } یافت نشد !`}</h4>
                    </div>
                ) : (
                    <>
                        {loadingPosts ? (
                            <div className={cx(styles.thumbNailContainer, "w-100")}>
                                {[1, 2, 3, 4, 5, 6].map((item, key) => (
                                    <NewsThumbNailLoadingSkeleton key={uuid()}/>
                                ))}
                            </div>
                        ) : (
                            <div className={cx(styles.thumbNailContainer)}>
                                {data?.length > 0 &&
                                    data?.map((item, key) => (
                                        <CardList
                                            id={item?.id}
                                            key={
                                                activePage || finalTag || activeSearch || finalCat ? uuid() : key
                                            }
                                            img={item?.img}
                                            imgAlt={item?.imgAlt}
                                            title={item?.title}
                                            cat={item?.cat}
                                            date={item?.date}
                                            dark={true}
                                            slug={item?.slug}
                                            duration={item?.duration}
                                            link={item.link}
                                        />
                                    ))}
                            </div>
                        )}
                    </>
                )}
            </div>
            {totalPage > 1 && (
                <div key={finalCat.slice(-1) + String(activeSearch)}>
                    <Pagination
                        totalPage={totalPage}
                        setActivePage={setActivePage}
                        activePage={activePage}
                        loading={loadingPosts}
                        pageNeedsRefresh={pageNeedsRefresh}
                        setPageNeedsRefresh={setPageNeedsRefresh}
                    />
                </div>
            )}
        </div>
    )
}

export default FilterList